module.exports = __webpack_public_path__ + "img/apple_download_256.0b7db517.png";